import { render } from "./warning.vue?vue&type=template&id=45e5ff22"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__